import { Component, OnInit, ViewChild } from '@angular/core';
import { Location } from '@angular/common';
import moment from 'moment';
import { serviceURLService } from '../service/serviceURL';
import { Router } from '@angular/router';
import { Subject } from 'rxjs/internal/Subject';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';

declare var $: any;

@Component({
  selector: 'app-plan-leave',
  templateUrl: './plan-leave.component.html',
  styleUrls: ['./plan-leave.component.css']
})
export class PlanLeaveComponent implements OnInit {
  @ViewChild('calendar', { static: true }) calendar: any;
  
  // State variables
  value: Date[] = [];
  invalidDates: any;
  error: any;
  data: any = {};
  comment: any;
  errorMessage: any;
  successMessage: any;
  userID: any;
  scheduledLeaves: any;
  storedDates: Array<any> = [];
  minimumDate = new Date();
  selectedDates: any[] = [];
  deselectedDates: any;
  unselectablePreviousDates: any;
  holidayDates: Array<any> = [];
  calendarData: any;
  loading: boolean = false;
  
  // Date and time variables
  currentTime: number;
  currentDate: number;
  startOfMonth: number;
  endOfMonth: number;
  
  // Leave tracking arrays
  leaveApplied: any[] = [];
  leaveCancelled: any[] = [];
  tempLeaveApplied: any[] = [];
  
  private onDestroy$: Subject<void> = new Subject<void>();

  constructor(
    private router: Router, 
    private serviceURLService: serviceURLService, 
    private _location: Location
  ) {
    this.userID = localStorage.getItem('userID');
    this.currentTime = this.parseTimeString(new Date().toLocaleTimeString());
    this.currentDate = new Date().setHours(0, 0, 0, 0);
  }

  ngOnInit() {
    this.getScheduledLeaves();
  }

  ngAfterViewChecked() {
    this.updateCalendarStyles();
  }

  // Calendar and Date Methods
  public onDateSelected(value: any) {
    let myMoment: moment.Moment = moment(value);
    this.data.leaveDate = [];
    this.data.leaveDate.push({
      'dateOfLeaves': this.value
    });
  }

  changedExtraHandler(event) {
    if (this.value.length > this.selectedDates.length) {
      this.handleLeaveApplication();
    } else if (this.selectedDates.length > this.value.length) {
      this.handleLeaveCancellation();
    } else if (this.selectedDates.length === this.value.length) {
      this.handleEqualLengthCase();
    }
    
    console.log("Leaves Applied: " + this.leaveApplied);
    console.log("Leaves Cancelled: " + this.leaveCancelled);
  }

  onMonthChange(event) {
    console.log(event);
    this.startOfMonth = new Date(event.year, event.month - 1, 1).getTime();
    this.endOfMonth = new Date(event.year, event.month, 0).getTime();
    this.getScheduledLeaves();
  }

  // Leave Operations
  submitLeaveAction() {
    if (this.leaveApplied.length > this.leaveCancelled.length) {
      this.applyPlanedLeaves();
    } else if (this.leaveApplied.length < this.leaveCancelled.length) {
      this.cancelLeaves();
    } else {
      this.showErrorMessage("Please select any date to perform action.");
    }
  }

  applyPlanedLeaves() {
    if (!this.comment) {
      this.showErrorMessage("Please add comment.");
      return;
    }

    const applyLeaveSelectedDates = this.leaveApplied.map(date => new Date(date).getTime());
    
    this.data = {
      "dateOfLeaves": applyLeaveSelectedDates,
      "comment": this.comment
    };
    
    this.serviceURLService.applyLeave(this.data, this.userID)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        successData => {
          $("#applyLeaveModal").modal("show");
          this.successMessage = successData['message'];
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        },
        errorData => {
          this.handleApplyLeaveError(errorData);
        }
      );
  }

  cancelLeaves() {
    const cancelLeaveSelectedDates = this.leaveCancelled.map(date => new Date(date).getTime());
    
    this.data = {
      "dateOfLeaves": cancelLeaveSelectedDates,
      "comment": this.comment
    };

    this.serviceURLService.cancelLeaveRequest(this.data, this.userID)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (successData: any) => {
          $("#applyLeaveModal").modal("show");
          this.successMessage = "Successfully cancelled";
        },
        errorData => {
          console.log("Not getting scheduled leaves");
        }
      );
  }

  // Helper Methods
  private handleLeaveApplication() {
    console.log("-------------ADDITION----------------");
    const leaveApplied = this.findNewAddedDate(this.value, this.selectedDates);
    const dateNotToDeselect = this.findNewAddedDate(this.selectedDates, this.value);
    
    if (dateNotToDeselect.length > 0) {
      this.showErrorMessage("To cancel leave please deselect the date you want to apply leave.");
      this.reSelectWrongSelectedDateWhileApplication(dateNotToDeselect);
    } else {
      this.leaveApplied = leaveApplied;
    }
  }

  private handleLeaveCancellation() {
    console.log("-------------CANCELLATION----------------");
    const leaveApplied = this.findNewAddedDate(this.value, this.selectedDates);
    
    if (leaveApplied.length > 0) {
      this.deSelectWrongSelectedDateWhileCancellation(leaveApplied[0]);
      this.showErrorMessage("Oops..!! You can't cancel the previous leave.");
    }

    const leaveCancelled = this.findNewAddedDate(this.selectedDates, this.value);
    this.processLeaveCancellation(leaveCancelled);
  }

  private handleEqualLengthCase() {
    console.log("Special case");
    
    if (this.leaveApplied.length > 0) {
      this.handleAppliedLeaveEqualCase();
    } else if (this.leaveCancelled.length > 0) {
      this.handleCancelledLeaveEqualCase();
    }
  }

  private handleAppliedLeaveEqualCase() {
    const dateNotToDeselect = this.findNewAddedDate(this.selectedDates, this.value);
    
    if (dateNotToDeselect.length > 0) {
      this.showErrorMessage("To apply leave please deselect the date you want to cancel leave.");
      this.reSelectWrongSelectedDateWhileApplication(dateNotToDeselect);
    } else {
      this.leaveApplied.length = 0;
    }
  }

  private handleCancelledLeaveEqualCase() {
    const isRejectionWithAppliedLeave = this.findNewAddedDate(this.value, this.selectedDates);
    
    if (isRejectionWithAppliedLeave.length > 0) {
      this.showErrorMessage("To cancel leave please deselect the date you want to apply leave.");
      this.deSelectWrongSelectedDateWhileCancellation(isRejectionWithAppliedLeave[0]);
    } else {
      this.leaveCancelled.length = 0;
    }
  }

  private processLeaveCancellation(leaveCancelled: any[]) {
    for (const cancelledDate of leaveCancelled) {
      if (cancelledDate < this.minimumDate) {
        this.showErrorMessage("Oops..!! You can't cancel the previous leave.");
        this.reSelectWrongSelectedDateWhileCancellation(cancelledDate);
      } else {
        this.addToCancelledLeavesIfNotExists(cancelledDate);
      }
    }

    this.removeRevokedCancelledLeaves(leaveCancelled);
  }

  private addToCancelledLeavesIfNotExists(cancelledDate: any) {
    const doesCancelledDateAlreadyExists = this.leaveCancelled.some(date => date == cancelledDate);
    
    if (!doesCancelledDateAlreadyExists) {
      this.leaveCancelled.push(cancelledDate);
    }
  }

  private removeRevokedCancelledLeaves(leaveCancelled: any[]) {
    this.leaveCancelled = this.leaveCancelled.filter(cancelledDate => {
      const isCancelledDateRevoked = leaveCancelled.some(date => date == cancelledDate);
      
      if (!isCancelledDateRevoked) {
        this.reSelectWrongSelectedDateWhileCancellation(cancelledDate);
        return false;
      }
      return true;
    });
  }

  findNewAddedDate(firstIterator: any[], secondIterator: any[]): any[] {
    return firstIterator.filter(date => 
      !secondIterator.some(secondDate => String(secondDate) === String(date))
    );
  }

  reSelectWrongSelectedDateWhileApplication(dateNotToDeselect: any[]) {
    this.value = [
      dateNotToDeselect[0],
      ...this.selectedDates.filter(date => date != dateNotToDeselect),
      ...this.leaveApplied
    ];
  }

  reSelectWrongSelectedDateWhileCancellation(dateNotToDeselect: any) {
    this.value = [
      dateNotToDeselect,
      ...this.selectedDates.filter(date => 
        !this.leaveCancelled.some(cancelled => cancelled == date) && date !== dateNotToDeselect
      )
    ];
  }

  deSelectWrongSelectedDateWhileCancellation(dateNotToDeselect: any) {
    this.value = this.selectedDates.filter(date => 
      !this.leaveCancelled.some(cancelled => cancelled == date) && date !== dateNotToDeselect
    );
  }

  // Calendar Styling Methods
  private updateCalendarStyles() {
    const activeElements = document.querySelectorAll('.p-highlight');
    activeElements.forEach((el) => {
      el.classList.remove('p-highlight');
    });

    this.applyLeaveStyles();
  }

  private applyLeaveStyles() {
  // Initialize tempLeaveApplied if it doesn't exist
  if (!this.tempLeaveApplied) {
    this.tempLeaveApplied = [];
  }
  
  // Find elements to remove styles from (in temp but not in current)
  const elementsToRemove = this.tempLeaveApplied.filter(element => 
    !this.leaveApplied.includes(element)
  );
  
  // Find elements to add styles to (in current but not in temp)
  const elementsToAdd = this.leaveApplied.filter(element => 
    !this.tempLeaveApplied.includes(element)
  );
  
  // Remove styles from elements that are no longer in leaveApplied
  elementsToRemove.forEach((element) => {
    const elementId = this.getDateElementId(element);
    if (elementId) {
      elementId.parentElement.classList.remove("ui-state-active-leave-apply");
      this.removeTodayStylesIfNeeded(elementId, element);
    }
  });
  
  // Add styles to new elements in leaveApplied
  elementsToAdd.forEach((element) => {
    const elementId = this.getDateElementId(element);
    if (elementId) {
      elementId.parentElement.classList.add("ui-state-active-leave-apply");
      this.removeTodayStylesIfNeeded(elementId, element);
    }
  });
  
  // Update tempLeaveApplied to track current state
  this.tempLeaveApplied = [...this.leaveApplied];
}

  private removeTodayStylesIfNeeded(elementId: any, element: any) {
    const today = new Date();
    const formattedDate = today.toISOString().slice(0, 10).replace(/-/g, '');
    
    if (elementId.id === formattedDate) {
      elementId.parentElement.classList.remove('absent-calendar-status');
      elementId.parentElement.classList.remove('ui-state-active');
      elementId.parentElement.parentElement.classList.remove('ui-datepicker-today');
    }
  }

  private getDateElementId(date: Date): any {
    const monthId = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1);
    const dateId = (date.getFullYear().toString() + monthId.toString() + date.getDate().toString());
    return document.getElementById(dateId);
  }

  // Data Fetching Methods
  getScheduledLeaves() {
    this.loading = true;
    
    this.data = this.getMonthData();
    this.value = this.selectedDates;

    this.serviceURLService.getScheduledLeaveCount(this.data, this.userID)
      .subscribe(
        (successData: any) => {
          this.processScheduledLeavesData(successData);
          this.loading = false;
        },
        errorData => {
          this.handleScheduledLeavesError(errorData);
        }
      );
  }

  private getMonthData() {
    if (this.startOfMonth && this.endOfMonth) {
      return {
        "updatedTime": null,
        "startOfMonth": this.startOfMonth,
        "endOfMonth": this.endOfMonth
      };
    }
    
    return {
      "updatedTime": null,
      "startOfMonth": null,
      "endOfMonth": null
    };
  }

  private processScheduledLeavesData(successData: any) {
    this.processCurrentDateStatus(successData);
    this.processHolidays(successData);
    this.processCheckInCheckOutData(successData);
    this.processScheduledLeaves(successData);
  }

  private processCurrentDateStatus(successData: any) {
    const calendarData = successData.response.scheduledLeavesOfUser;
    const isCurrentDateMatchedWithLeave = calendarData.some(leave => 
      Number(leave.dateOfLeave) === this.currentDate
    );
    const isCurrentDateMatchedWithHoliday = successData.response.holidayForUser.some(holiday => 
      Number(holiday.dateOfHoliday) === this.currentDate
    );
    
    const elementToday = this.getTodayElement();
    
    if (this.currentTime > 35100 && (!isCurrentDateMatchedWithLeave && !isCurrentDateMatchedWithHoliday)) {
      if (elementToday) {
        elementToday.parentElement.classList.add("absent-calendar-status");
      }
    }
  }

  private getTodayElement(): any {
    const appliedDateToday = new Date();
    const monthToday = (appliedDateToday.getMonth() + 1 < 10 ? '0' + (appliedDateToday.getMonth() + 1) : appliedDateToday.getMonth() + 1);
    const dateIdToday = (appliedDateToday.getFullYear().toString() + monthToday.toString() + appliedDateToday.getDate().toString());
    return document.getElementById(dateIdToday);
  }

  private processHolidays(successData: any) {
    successData.response.holidayForUser.forEach(holiday => {
      const appliedDate = new Date(holiday.dateOfHoliday);
      const element = this.getDateElement(appliedDate);
      
      if (element) {
        element.parentElement.classList.add('custom-disabled');
      }
    });
  }

  private processCheckInCheckOutData(successData: any) {
    const filteredData = successData.response.checkInCheckOutData.filter(
      checkInCheckOutData => (checkInCheckOutData.checkInStatus !== 'Weekly Off' || checkInCheckOutData.checkOutStatus !== 'Weekly Off')
    );

    filteredData.forEach(data => {
      this.processCheckInCheckOutItem(data);
    });
  }

  private processCheckInCheckOutItem(data: any) {
    const appliedDate = new Date(data.dateOfCheckIn * 1);
    const element = this.getDateElement(appliedDate);

    if (!element) return;

    this.applyCheckInCheckOutStyles(element, data, appliedDate);
    this.selectedDates.push(appliedDate);
  }

  private applyCheckInCheckOutStyles(element: any, data: any, appliedDate: Date) {
    const checkInTime = this.getTotalSecondsFromDate(data.currentCheckInTime);
    const checkoutTime = this.getTotalSecondsFromDate(data.currentCheckOutTime);

    // Current date with pending checkout
    if ((data.checkInStatus === 'IN' || data.checkInStatus === 'PENDING') && 
        data.checkOutStatus === '' && 
        this.currentDate === data.dateOfCheckIn * 1) {
      element.parentElement.classList.add("approved-inout-calendar-status");
    }

    // Late checkout pending
    if ((data.checkInStatus === 'IN' || data.checkInStatus === 'PENDING') && 
        data.checkOutStatus === '' && 
        (this.currentTime >= 68400 || checkInTime >= 68400 || this.currentDate > data.dateOfCheckIn * 1)) {
      element.parentElement.classList.add("checkout-pending-calendar-status");
    }

    // Checked out on time
    if ((data.checkInStatus === 'IN' || data.checkInStatus === 'PENDING') && 
        data.checkOutStatus !== '' && 
        (checkoutTime <= 86340) && 
        this.currentDate === data.dateOfCheckIn * 1) {
      element.parentElement.classList.add("approved-inout-calendar-status");
    }

    // Pending attendance approval for past dates
    if ((data.checkInStatus === 'PENDING' || data.checkOutStatus === 'PENDING') &&
        this.currentDate > data.dateOfCheckIn * 1) {
      element.parentElement.classList.add("unapproved-attendance-calendar-status");
    }

    // Absent
    if (data.checkInStatus === "ABSENT" && data.checkOutStatus === "ABSENT") {
      element.parentElement.classList.add("absent-calendar-status");
    }

    // Checked in and out
    if (data.checkInStatus === "IN" && data.checkOutStatus === "OUT") {
      element.parentElement.classList.add("approved-inout-calendar-status");
    }
  }

  private processScheduledLeaves(successData: any) {
    successData.response.scheduledLeavesOfUser.forEach(leave => {
      this.processScheduledLeaveItem(leave);
    });
  }

  private processScheduledLeaveItem(leave: any) {
    const appliedDate = new Date(leave.dateOfLeave * 1);
    const element = this.getDateElement(appliedDate);

    if (!element) return;

    this.applyLeaveStatusStyles(element, leave);
    this.selectedDates.push(appliedDate);
  }

  private applyLeaveStatusStyles(element: any, leave: any) {
    element.parentElement.classList.remove("absent-calendar-status");

    switch (leave.leaveStatus) {
      case "Unpaid":
        element.parentElement.classList.add("unpaid-leave-calender-status");
        break;
      case "Paid":
        element.parentElement.classList.add("paid-leave-calender-status");
        break;
      case "Rejected":
        element.parentElement.classList.add("rejected-leave-calender-status");
        break;
      case "PENDING":
        element.parentElement.classList.add("ui-state-active-leave");
        break;
    }
  }

  private getDateElement(date: Date): any {
    const month = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1);
    const dateId = (date.getFullYear().toString() + month.toString() + date.getDate().toString());
    return document.getElementById(dateId);
  }

  // Error Handling Methods
  private handleApplyLeaveError(errorData: any) {
    this.errorMessage = errorData.error.message;
    
    if (errorData.error.status === 400) {
      this.errorMessage = errorData.error.message;
    } else {
      $("#serverErrorMessage").modal("show");
      setTimeout(() => {
        $("#serverErrorMessage").modal("hide");
      }, 2000);
    }
  }

  private handleScheduledLeavesError(errorData: any) {
    if (errorData.error.status === 401) {
      this.router.navigate(['/login']);
      console.log("Please login first");
    } else if (errorData.error.status === 403 || errorData.error.status === 400) {
      this.error = errorData.error.message;
      console.log("ERROR: ", this.error);
    }
  }

  private showErrorMessage(message: string) {
    $("#ignoreSelection").modal("show");
    this.getScheduledLeaves();
    $(".errorMessage").text(message);
  }

  // Utility Methods
  parseTimeString(timeString: string): number {
    timeString = timeString.trim().toUpperCase();

    if (timeString.includes('AM') || timeString.includes('PM')) {
      const [time, period] = timeString.split(' ');
      const [hours, minutes, seconds] = time.split(':').map(Number);

      let adjustedHours = hours;
      if (period === 'PM' && hours !== 12) {
        adjustedHours += 12;
      } else if (period === 'AM' && hours === 12) {
        adjustedHours = 0;
      }

      return (adjustedHours * 3600) + (minutes * 60) + seconds;
    } else {
      const [hours, minutes, seconds] = timeString.split(':').map(Number);
      return (hours * 3600) + (minutes * 60) + seconds;
    }
  }

  getTotalSecondsFromDate(timestamp: any): number {
    const date = new Date(timestamp);
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const seconds = date.getSeconds();
    return (hours * 3600) + (minutes * 60) + seconds;
  }

  backClicked() {
    this._location.back();
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }
}